<template>
  <div class="page">
    <div class="block" v-loading="loading">
      <el-card>
        <h2>{{ book.title }}</h2>
        <div class="block">
          <div class="picture">
            <img v-if="book.cover" :src="book.cover" />
            <img v-else src="../../assets/default_book.jpg" />
          </div>
          <div class="description">
            <p>{{ book.description }}</p>
            <h4 v-if="book.authors">
              Autor(es): {{ book.authors.join(", ") }}
            </h4>
            <h4 v-if="book.city">Cidade: {{ book.city }}</h4>
            <h4 v-if="book.publisher">Editora: {{ book.publisher }}</h4>
            <h4 v-if="book.edition">Edição: {{ book.edition }}</h4>
            <h4 v-if="book.year">Ano: {{ book.year }}</h4>
            <h4 v-if="book.isbn">ISBN: {{ book.isbn }}</h4>
            <h4>{{ book.code }}</h4>
            <el-space v-if="tags">
              <el-check-tag
                checked
                v-for="tag in tags"
                :key="tag"
                @click="goToTag(tag._id.$oid)"
                >{{ tag.value }}</el-check-tag
              >
            </el-space>
          </div>
        </div>
        <el-rate
          v-model="rating"
          text-color="#ff9900"
          @change="rateBook"
          allow-half
        >
        </el-rate>
      </el-card>

      <el-divider></el-divider>
      <div
        class="comment"
        v-if="$store.state.user != null && $store.state.user._id != null"
      >
        <el-row>
          <el-input
            id="commentField"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Comentário"
            v-model="comment.body"
          />
        </el-row>
        <br />
        <el-row>
          <el-button type="primary" @click="addComment">Comentar</el-button>
        </el-row>
      </div>
      <br />
      <div class="comments-table" id="item">Comentários</div>
      <el-timeline id="comments">
        <section v-for="comment in comments.items" :key="comment">
          <el-timeline-item
            :timestamp="convertToLocalTimezone(comment.created_at)"
            placement="top"
          >
            <el-card>
              <p>{{ comment.body }}</p>
              <h4 v-if="comment.username">@{{ comment.username }}</h4>
              <a
                v-if="canDeleteComment(comment)"
                @click="deleteComment(comment._id.$oid)"
                >Deletar comentário</a
              >
            </el-card>
          </el-timeline-item>
        </section>
      </el-timeline>
      <el-pagination
        layout="total, prev, pager, next"
        :total="comments.count"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getBook, rateBook } from "../../services/book";
import { getBookTags } from "../../services/tags";
import {
  createComment,
  getBookComments,
  deleteComment,
} from "../../services/comment";
export default {
  name: "Details",
  data() {
    return {
      comment: {
        body: "",
      },
      rating: "",
      book: {},
      comments: {},
      currentPage: 1,
      complete: false,
      tags: [],
    };
  },
  methods: {
    goToTag(tag) {
      this.$router.push({ path: "/", query: { tag: tag } });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBookComments();
      const el = document.getElementById("item");
      el.scrollIntoView({ behavior: "smooth" });
    },
    canDeleteComment(comment) {
      if (
        this.$store.state.user == null ||
        this.$store.state.user._id == null
      ) {
        return false;
      }
      return (
        comment.user_id.$oid == this.$store.state.user._id.$oid ||
        this.$store.state.user.user_type == "moderator" ||
        this.$store.state.user.user_type == "admin"
      );
    },
    async deleteComment(comment_id) {
      var requestBody = {
        comment_id: comment_id,
      };
      const response = await deleteComment(this.$route.params.id, requestBody);
      if (response.status === 200) {
        this.$message.success("Comentário deletado!");
        this.getBookComments();
      }
    },
    async rateBook() {
      rateBook(this.$route.params.id, { value: this.rating });
      setTimeout(() => {
        getBook(this.$route.params.id).then((response) => {
          this.rating = response.data.rating;
        });
      }, 1000);
    },
    delay(n) {
      return new Promise(function (resolve) {
        setTimeout(resolve, n * 1000);
      });
    },
    async addComment() {
      this.comment.book_id = this.$route.params.id;
      const response = await createComment(this.$route.params.id, this.comment);
      if (response.status === 201) {
        this.$message.success("Comentário publicado com sucesso!");
        this.currentPage = 1;
        this.getBookComments();
        document.getElementById("commentField").value = "";
      }
    },

    getBookTags() {
      getBookTags(this.$route.params.id).then((response) => {
        this.tags = response.data;
      });
    },

    getBookComments() {
      const params = {
        per_page: 10,
      };
      params.page = this.currentPage;
      getBookComments(this.$route.params.id, params).then((response) => {
        this.comments = response.data;
      });
    },
    loadDataFromServer() {
      this.currentPage++;
      this.getBookComments();
    },

    async getBook(id) {
      const response = await getBook(id);
      this.book = response.data;
      if (this.book.rating) {
        this.rating = this.book.rating;
      }
    },

    convertToLocalTimezone(UTCDate) {
      var date = new Date(UTCDate);
      return (
        String("0" + date.getDate()).slice(-2) +
        "/" +
        String("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        String(date.getFullYear()) +
        " - " +
        String("0" + date.getHours()).slice(-2) +
        ":" +
        String("0" + date.getMinutes()).slice(-2)
      );
    },
  },
  created() {
    this.getBook(this.$route.params.id);
    this.getBookComments();
    this.getBookTags();
  },
};
</script>
<style scoped>
.picture {
  display: table-cell;
  margin-right: 10px;
}

img {
  min-width: 100px;
  min-height: 100px;
  max-width: 300px;
  max-height: 300px;
}

.description {
  height: 100px;
  display: table-cell;
  padding: 20px;
  vertical-align: top;
}

p {
  margin-bottom: 10px;
}

.comment {
  margin: 10px;
}

a {
  text-decoration: underline;
  cursor: pointer;
}

.page {
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
  margin-top: 2%;
}

.comments-table {
  margin: 10px;
}
</style>
